import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import { Trans, useTranslation } from "react-i18next";
import { CHECKLISTS } from "../../../locales/pages/namespaces";

const CheckListInfo = () => {
	const { t } = useTranslation(CHECKLISTS)
	return (
		<Box sx={{ maxWidth: 1200, lineHeight: 1.7, padding: {xs: 1.6, sm: 2, md: 2, lg: 4} }}>
			<Typography variant="h5" gutterBottom color="secondary">
				{t('Daily Cleaning Duties')}
			</Typography>
			<Trans
				i18nKey={'daily_duties'}
				ns={CHECKLISTS}/>
			<Divider sx={{ my: 4 }}/>
			<Typography variant="h5" gutterBottom color="secondary">
				{t('Weekly Cleaning Duties')}
			</Typography>
			<Trans
				i18nKey={'weekly_duties'}
				ns={CHECKLISTS}/>
			<Divider sx={{ my: 4 }}/>
			<Typography variant="h5" gutterBottom color="secondary">
				{t('Monthly Cleaning Duties')}
			</Typography>
			<Trans
				i18nKey={'monthly_duties'}
				ns={CHECKLISTS}/>
			<Divider sx={{ my: 4 }}/>
			<Typography variant="h5" gutterBottom color="secondary">
				{t('Trimester Cleaning Duties')}
			</Typography>
			<Trans
				i18nKey={'trimester_duties'}
				ns={CHECKLISTS}/>
		</Box>
	);
};

export default CheckListInfo